export const MEMBER_TOKEN = "ur-admin-session";
export const PROFILE_ADDRESS_INFO_CACHE = "ur-profile-info-cache";
export const CURRENT_SUB_ORDER = "ur-current-sub-order-id";
export const USER_MENU_HISTORY = "ur-user-menu-history";
